/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Count_Not_A_Positive_IntegerInputs */

const en_us2_workout_count_not_a_positive_integer = /** @type {(inputs: Workout_Count_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The number of reps has to be a whole number above zero.`)
};

const pt_br2_workout_count_not_a_positive_integer = /** @type {(inputs: Workout_Count_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número de repetições precisa ser um número inteiro maior que zero.`)
};

const es_419_workout_count_not_a_positive_integer = /** @type {(inputs: Workout_Count_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El número de repeticiones tiene que ser un número entero mayor que cero.`)
};

const pt_pt2_workout_count_not_a_positive_integer = /** @type {(inputs: Workout_Count_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O número de repetições tem de ser um número inteiro maior do que zero.`)
};

const fr_fr2_workout_count_not_a_positive_integer = /** @type {(inputs: Workout_Count_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nombre de répétitions doit être un nombre entier supérieur à zéro.`)
};

const de_de2_workout_count_not_a_positive_integer = /** @type {(inputs: Workout_Count_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zahl der Wiederholungen muss eine ganze Zahl über null sein.`)
};

const it_it2_workout_count_not_a_positive_integer = /** @type {(inputs: Workout_Count_Not_A_Positive_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il numero di ripetizioni deve essere un numero intero maggiore di zero.`)
};

/**
* | output |
* | --- |
* | "The number of reps has to be a whole number above zero." |
*
* @param {Workout_Count_Not_A_Positive_IntegerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_count_not_a_positive_integer = /** @type {((inputs?: Workout_Count_Not_A_Positive_IntegerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Count_Not_A_Positive_IntegerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_count_not_a_positive_integer(inputs)
	if (locale === "es-419") return es_419_workout_count_not_a_positive_integer(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_count_not_a_positive_integer(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_count_not_a_positive_integer(inputs)
	if (locale === "de-DE") return de_de2_workout_count_not_a_positive_integer(inputs)
	if (locale === "it-IT") return it_it2_workout_count_not_a_positive_integer(inputs)
	return en_us2_workout_count_not_a_positive_integer(inputs)
});
export { workout_count_not_a_positive_integer as "workout.count_not_a_positive_integer" }